export const toBase64 = (file, stripDataUrl = false) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () =>
      resolve(stripDataUrl ? reader.result.split(',')[1] : reader.result)
    reader.onerror = error => reject(error)
  })
